import { c as _c } from "react/compiler-runtime";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Image from "next/image";
import { isEntry } from "@/lib/contentful/guards";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
import type { ValuePropEntry } from "./ValuePropsCard";
interface Props {
  item: ValuePropEntry;
}
export const ValuePropItem = t0 => {
  const $ = _c(15);
  const {
    item
  } = t0;
  const {
    image,
    headline,
    description
  } = item.fields;
  const resolvedImage = isEntry(image) ? image : undefined;
  let t1;
  if ($[0] !== resolvedImage) {
    t1 = resolvedImage ? ContentfulHelper.parseContentfulContentImage(resolvedImage.fields.media) : undefined;
    $[0] = resolvedImage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contentImage = t1;
  let t2;
  if ($[2] !== contentImage || $[3] !== headline) {
    t2 = contentImage && <div className="relative aspect-square h-23.5 shrink-0"><Image src={contentImage.src} alt={contentImage.alt || headline} fill={true} className="object-contain" sizes="94px" /></div>;
    $[2] = contentImage;
    $[3] = headline;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== headline) {
    t3 = <h3 className="heading-sm text-left md:text-center">{headline}</h3>;
    $[5] = headline;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== description) {
    t4 = description && <div className="text-base text-left md:text-center">{documentToReactComponents(description)}</div>;
    $[7] = description;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex flex-col gap-1 md:items-center">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <div className="flex flex-1 min-w-0 flex-row items-center gap-6 md:flex-col md:gap-2 md:justify-start md:w-full">{t2}{t5}</div>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};